/**
 * IMPORTS
 */
import {t} from 'i18next';


/**
 * TYPES
 */
import {IFeedbackMessages} from 'src/aggregates/utils/feedback';


/**
 * CONSTANTS AND DEFINITIONS
 */
const messages: IFeedbackMessages = {
    'PCZCV0002E': t('Microfone não encontrado. Por favor, verifique se o dispositivo está conectado e funcionando corretamente.'),
    'PCZCV0003E': t('Você deve permitir o uso do microfone pela aplicação.'),
    'PCZCV0004E': t('Falha inesperada ao tentar gravar o áudio. Cheque seu equipamento.'),
};


/**
 * EXPORTS
 */
export {
    messages,
};
